<template xmlns="http://www.w3.org/1999/html">
  <div class="invoice-form-viewer">
    <div class="header">
      <h4 class="title">{{ generateTitle }}</h4>
      <p class="date">{{ issuedDate }}</p>
      <!--      <p class="italic">VAT INVOICE</p>-->
      <p class="description" v-html="generateDescription"></p>
      <!--      <p class="italic">Invoice converted from electronic invoice</p>-->
      <div class="top-left-content">
        <div v-if="checkValidInvoice === 2" class="check-valid-invoice">
          <div class="icon">
            <i class="far fa-check" style="color: #2BD700;"></i>
          </div>
          <p>
            {{ $t('viewer.header.top-left.checked') }}
          </p>
        </div>
        <div v-if="checkValidInvoice === 0" class="uncheck-valid-invoice">
          <div class="icon">
            <i class="fad fa-comment-exclamation fa-flip-horizontal" style="--fa-primary-color: #FFFFFF; --fa-secondary-color: #005DCA; --fa-secondary-opacity: 1;"></i>
          </div>
          <p>
            {{ $t('viewer.header.top-left.unchecked') }}
          </p>
        </div>
        <app-btn-submit
          v-if="checkValidInvoice === 0 && (formModel.seller_name && formModel.seller_address && formModel.seller_taxcode)"
          :text="checkValidLoading ? $t('viewer.header.top-left.actions.loading') : $t('viewer.header.top-left.actions.verify')"
          @on-click="onVerifyInvoice"
          :isSubmitting="checkValidLoading"
        ></app-btn-submit>
      </div>
      <div class="top-right-content">
        <invoice-form-viewer-field labelSpan="6" textSpan="6" :label="'Ký hiệu'" :textBold="true" :text="formModel.invoice_serial" />
        <invoice-form-viewer-field labelSpan="6" textSpan="6" :label="'Số hóa đơn'" :textBold="true" :text="formModel.invoice_number" />
      </div>
    </div>
    <hr />
    <div class="row mt-2 px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field
          :label="'Đơn vị bán hàng'"
          :text="formModel.seller_name"
          :correct-text="isFieldError(!formModel.kind_of, 'company_name_error', 'correct_company_name')"
          :company-situation="isFieldError(!formModel.kind_of, 'warning', 'company_situation')"
          :missing-content="!formModel.seller_name"
          :is-correct="isFieldCorrect(!formModel.kind_of, 'company_name_error', true)"
          text-bold
        />
      </div>
    </div>
    <div class="row px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field
          :label="'Địa chỉ'"
          :text="formModel.seller_address"
          :correct-text="isFieldError(!formModel.kind_of, 'address_error', 'correct_address')"
          :is-correct="isFieldCorrect(!formModel.kind_of, 'address_error')"
          :missing-content="!formModel.seller_address"
        />
      </div>
    </div>
    <div class="row px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field
          :label="'Mã số thuế'"
          :is-show-default="true"
          :text="formModel.seller_taxcode"
          :correct-text="isFieldError(!formModel.kind_of, 'tax_risk', 'tax_risk_status')"
          :is-correct="isFieldCorrect(!formModel.kind_of, 'tax_risk')"
          :missing-content="!formModel.seller_taxcode"
        />
      </div>
    </div>
    <!--    <div class="row px-15px">-->
    <!--      <div class="col-4">-->
    <!--        <invoice-form-viewer-field :label="'Điện thoại'" />-->
    <!--      </div>-->
    <!--      <div class="col-4">-->
    <!--        <invoice-form-viewer-field :label="'Website'"  />-->
    <!--      </div>-->
    <!--      <div class="col-4">-->
    <!--        <invoice-form-viewer-field :label="'Email'" />-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="row px-15px">
      <div class="col-6 p-0">
        <invoice-form-viewer-field :labelSpan="6" :textSpan="6" :label="'Số tài khoản'"
          :text="formModel.seller_account_number" />
      </div>
      <div class="col-6 p-0">
        <invoice-form-viewer-field :label="'Ngân hàng'" :labelSpan="3" :textSpan="9"
          :text="formModel.seller_bank_name" />
      </div>
    </div>

    <div class="row px-15px">
      <div class="col-6 p-0">
        <invoice-form-viewer-field :labelSpan="6" :textSpan="6" :label="'Số căn cước công dân'"
          :text="formModel.buyer_id_no" />
      </div>
      <div class="col-6 p-0">
        <invoice-form-viewer-field :label="'Số hộ chiếu'" :labelSpan="3" :textSpan="9"
          :text="formModel.buyer_passport_no" />
      </div>
    </div>

    <div class="row px-15px">
      <div class="col-6 p-0">
        <invoice-form-viewer-field :labelSpan="6" :textSpan="6" :label="'Mã đơn vị quan hệ ngân sách'"
          :text="(formModel.metadata && formModel.metadata.buyer_obj) ? formModel.metadata.buyer_obj.mdvqhnsach : ''" />
      </div>
    </div>

    <!-- <div class="row px-15px">
      <div class="col-6 p-0">
        <invoice-form-viewer-field :labelSpan="6" :textSpan="6" :label="'Loai nguoi mua'"
          :text="(formModel.metadata && formModel.metadata.buyer_obj) ? formModel.metadata.buyer_obj.buyer_type : ''" />
      </div>
    </div> -->

    <div class="row mt-4 px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field :label="'Họ tên người mua'" :text="formModel.buyer_name" text-bold />
      </div>
    </div>
    <div class="row px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field
          :label="'Tên đơn vị'"
          :text="formModel.buyer_legal_name"
          :correct-text="isFieldError(formModel.kind_of, 'company_name_error', 'correct_company_name')"
          :company-situation="isFieldError(formModel.kind_of, 'warning', 'company_situation')"
          :is-correct="isFieldCorrect(formModel.kind_of, 'company_name_error', true)"
          :suppress-checks="shouldSuppressChecks"
        />
      </div>
    </div>
    <div class="row px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field
          :label="'Địa chỉ'"
          :text="formModel.buyer_address"
          :correct-text="isFieldError(formModel.kind_of, 'address_error', 'correct_address')"
          :is-correct="isFieldCorrect(formModel.kind_of, 'address_error')"
          :suppress-checks="shouldSuppressChecks"
        />
      </div>
    </div>
    <div class="row px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field
          :label="'Mã số thuế'"
          :is-show-default="true"
          :text="formModel.buyer_taxcode"
          :correct-text="isFieldError(formModel.kind_of, 'tax_risk', 'tax_risk_status')"
          :is-correct="isFieldCorrect(formModel.kind_of, 'tax_risk')"
          :suppress-checks="shouldSuppressChecks"
        />
      </div>
    </div>
    <div class="row px-15px">
      <div class="col-12 p-0">
        <invoice-form-viewer-field :label="'Hình thức thanh toán'" :text="generatePaymentMethod" />
      </div>
    </div>

    <template v-if="formModel.metadata && formModel.metadata.data_plus_for_phieu_xkvc && invoiceType === '6'">
      <div class="row mt-4 px-15px">
        <div class="col-12 p-0">
          <invoice-form-viewer-field :label="'Lệnh điều động nội bộ'" :text="formModel.metadata.data_plus_for_phieu_xkvc.NBan_LDDNBo" />
        </div>
      </div>
      <div class="row px-15px">
        <div class="col-12 p-0">
          <invoice-form-viewer-field :label="'Phương tiện vận chuyển'" :text="formModel.metadata.data_plus_for_phieu_xkvc.NBan_PTVChuyen" />
        </div>
      </div>
      <div class="row px-15px">
        <div class="col-12 p-0">
          <invoice-form-viewer-field :label="'Hợp đồng số'" :text="formModel.metadata.data_plus_for_phieu_xkvc.NBan_HDSo" />
        </div>
      </div>
      <div class="row px-15px">
        <div class="col-12 p-0">
          <invoice-form-viewer-field :label="'Địa chỉ kho xuất hàng'" :text="formModel.metadata.data_plus_for_phieu_xkvc.NBan_DChi" />
        </div>
      </div>
      <div class="row px-15px">
        <div class="col-12 p-0">
          <invoice-form-viewer-field :label="'Tên người vận chuyển'" :text="formModel.metadata.data_plus_for_phieu_xkvc.NBan_TNVChuyen" />
        </div>
      </div>
      <div class="row px-15px">
        <div class="col-12 p-0">
          <invoice-form-viewer-field :label="'Họ và tên người xuất hàng'" :text="formModel.metadata.data_plus_for_phieu_xkvc.NBan_HVTNXHang" />
        </div>
      </div>
    </template>

    <table class="table mt-4 table-sm">
      <thead>
        <tr>
          <th style="width: 5%">{{ $t('invoice.stt') }}</th>
          <th style="width: 25%">{{ $t('invoice.nameOfGoodsAndServices') }}</th>
          <th style="width: 10%">{{ $t('invoice.unit') }}</th>
          <th style="width: 10%">{{ $t('invoice.quantity') }}</th>
          <th style="width: 10%">{{ $t('invoice.unitPrice') }}</th>
          <th style="width: 10%">{{ $t('invoice.amount') }}</th>
          <th style="width: 10%">{{ $t('invoice.vatRate') }}</th>
          <th style="width: 10%">{{ $t('invoice.taxAmount') }}</th>
          <th style="width: 10%" class="text-right">{{ $t('invoice.total') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="generateContent" v-for="(item, index) in generateContent" :key="index">
          <td>{{ item.PRODUCT_NO }}</td>
          <td>{{ item.PRODUCT_DESC }}</td>
          <td>{{ item.PRODUCT_UNIT }}</td>
          <td>{{ item.PRODUCT_QUANTITY }}</td>
          <td>{{ formatCurrency(item.PRODUCT_UNIT_PRICE, item.PRODUCT_TYPE) }}</td>
          <td>{{ formatCurrency(item.PRODUCT_AMOUNT, item.PRODUCT_TYPE) }}</td>
          <td :class="{'text-center': !item.PRODUCT_VAT_RATE}">{{ item.PRODUCT_VAT_RATE || "\\" }}</td>
          <td>{{ formatCurrency(item.PRODUCT_TAX_AMOUNT, item.PRODUCT_TYPE) }}</td>
          <td class="text-right">{{ formatCurrency(item.PRODUCT_TOTAL_AMOUNT, item.PRODUCT_TYPE) }}</td>
        </tr>
        <tr v-if="!generateContent && !isDraftInvoice">
          <td colspan="9">
            <p v-if="detailsInvoiceLoading" class="content">{{$t('invoice.viewContent.loading')}}</p>
            <div v-if="!detailsInvoiceLoading" class="content">
              <p v-if="isGetDetailError" class="text-danger">{{$t('invoice.viewContent.error.connection')}}</p>
              <button
                type="button"
                class="btn"
                :class="isGetDetailError ? 'btn-danger' : 'btn-outline-primary custom-btn'"
                @click="onGetContent"
              >
                {{isGetDetailError ? $t('invoice.viewContent.error.button') : $t('invoice.viewContent.button')}}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="view-total-container">
      <div class="view-total-content">
        <div class="view-total-item">
          <label>Tổng tiền chưa thuế</label>
          <span>{{ formModel.total_amount_without_tax | formatNumber }} {{ formModel.currency_unit }}</span>
        </div>
        <div class="view-total-item">
          <label>Tổng tiền thuế</label>
          <span>{{ formModel.tax_amount | formatNumber }} {{ formModel.currency_unit }}</span>
        </div>
        <div class="view-total-item">
          <label>Tổng tiền cần thanh toán</label>
          <span>{{ formModel.total_amount_with_tax | formatNumber }} {{ formModel.currency_unit }}</span>
        </div>
      </div>
    </div>
    <div class="row signature">
      <div class="col-6 text-center">
        <div>
          <strong>Người mua hàng</strong>
        </div>
        <span>(Chữ ký số (nếu có))</span>
      </div>
      <div class="col-6 d-flex flex-column align-items-center justify-content-center">
        <div>
          <strong>Người bán hàng</strong>
        </div>
        <span>(Chữ ký số, chữ ký điện tử)</span>
        <div v-show="formModel.signed_date" class="p-sign">
          <div class="content">
            <p class="valid">Signature Valid</p>
            <p class="company">Ký bởi <strong>{{formModel.seller_name}}</strong></p>
            <p class="date">Ký ngày: {{ signedDate }}</p>
          </div>
          <div class="icon">
            <i class="far fa-check fa-lg" style="color: #2BD700; font-size: 36px"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="invoice-form-footer">
      <div class="tax-code">
        <p>Mã cơ quan thuế: </p><strong>{{ formModel.cqt_code }}</strong>
      </div>
      <p class="text-center">Cảm ơn bạn đã sử dụng dịch vụ của CÔNG TY CỔ PHẦN PHẦN MỀM PVS </p>
    </div>
    <!-- <img class="background" src="/images/thue-nha-nuoc.png" alt="Invoice background"/> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DateTimeUtils from '@/utils/datetime';
import { parseInvoiceContent } from '@/utils/invoice';
import AppBtnSubmit from '@/components/app-button';
import InvoiceFormViewerField from '@/portal-components/invoice/invoice-form-viewer-field';
import NumericUtils from '../../utils/numeric';
import { BUYER_TYPE, PRODUCT_TYPE } from '../../app-constant';

export default {
  name: 'InvoiceFormViewer',
  components: {
    AppBtnSubmit,
    InvoiceFormViewerField,
  },
  props: {
    formModel: Object,
  },
  data() {
    return {
      isGetDetailError: false,
      checkValidLoading: false,
      // keyword: {
      //   expired: 'hết hạn',
      //   tax_authority: 'Cơ Quan Thuế',
      //   status_401: '401',
      //   status_500: '500',
      // },
    };
  },
  beforeDestroy() {
    this.$bus.off('verify-invoice-success', this.onVerifyInvoiceSuccess);
  },
  created() {
    this.$bus.on('verify-invoice-success', this.onVerifyInvoiceSuccess);
  },
  mounted() {
    if (this.formModel.id && !this.detailsInvoice.has(this.formModel.id) && !this.formModel.content) this.onGetContent();
  },
  methods: {
    ...mapActions(['getDetailInvoice', 'setState']),
    formatCurrency(value, type) {
      const isEmpty = value === null || value === undefined || isNaN(value);

      if (isEmpty) {
        switch (type) {
          case PRODUCT_TYPE.PRODUCT:
            return '0';
          default:
            return '';
        }
      }

      return NumericUtils.formatNumber(value);
    },
    isFieldError(kindOf = true, status = '', returnField = '') {
      if (!this.formModel.customer_invalid_data) return '';

      if (status && returnField) {
        const data = this.formModel.customer_invalid_data;
        if (kindOf && data[status]) {
          return data[returnField];
        }
      }
      return '';
    },
    isFieldCorrect(kindOf = true, status = '', isWarning = false) {
      if (!this.formModel.customer_invalid_data) return true;
      const { correct_address, correct_company_name, [status]: statusData, warning } = this.formModel.customer_invalid_data;
      // eslint-disable-next-line camelcase
      const isNoneChecked = (correct_address === 'N/A' && correct_company_name === 'N/A') || (!correct_address && !correct_company_name);
      if (!kindOf || isNoneChecked || !status) return false;
      return !(statusData || (isWarning && warning));
    },
    onGetContent() {
      this.getDetailInvoice({ id: this.formModel.id })
        .then(() => {
          this.isGetDetailError = false;
        })
        .catch(() => {
          this.isGetDetailError = true;
          // if (e.status_code === 400) {
          //   if (e.message.includes(this.keyword.expired) || e.message.includes(this.keyword.status_401)) {
          //     this.$modal.show('tax-account-connect-modal', { model: { isUpdatePassword: false } });
          //   } else if (e.message.includes(this.keyword.tax_authority) || e.message.include(this.keyword.status_500)) {
          //     ToastUtils.showToast('error', this.$t('invoice.viewContent.error.500'));
          //   }
          //   ToastUtils.showToast('error', this.$t('invoice.viewContent.error.500'));
          // } else {
          //   ToastUtils.showToast('error', this.$t('invoice.viewContent.error.connection'));
          // }
        },
      );
    },
    onVerifyInvoice($event) {
      $event.preventDefault();
      $event.stopPropagation();
      this.checkValidLoading = true;
      this.$emit('on-verify-invoice', {
        id: this.formModel.id,
        kindOf: this.formModel.kind_of,
        buyerTaxCode: this.formModel.buyer_taxcode,
        sellerTaxCode: this.formModel.seller_taxcode,
      });
    },
    onVerifyInvoiceSuccess() {
      this.checkValidLoading = false;
    },
  },
  computed: {
    ...mapState(['detailsInvoice', 'detailsInvoiceLoading']),
    shouldSuppressChecks() {
      const metadata = this.formModel.metadata
      if (metadata && metadata.buyer_obj) {
        const buyer_type = metadata.buyer_obj.buyer_type
        return buyer_type === BUYER_TYPE.PERSONAL
      }
    },
    isDraftInvoice() {
      return this.formModel.invoice_type === 'DRAFT' || this.formModel.releasing_status === 'draf';
    },
    checkValidInvoice() {
      if (!this.formModel.customer_invalid_data) return 2;
      const { correct_address, correct_company_name, warning, tax_risk, company_name_error, address_error } = this.formModel.customer_invalid_data;
      // eslint-disable-next-line camelcase
      const isNoneChecked = (correct_address === 'N/A' && correct_company_name === 'N/A') || (!correct_address && !correct_company_name);
      if (isNoneChecked) {
        return 0;
      }
      // eslint-disable-next-line camelcase
      if (warning || tax_risk || company_name_error || address_error) {
        return 1;
      }
      return 2;
    },
    issuedDate() {
      if (!this.formModel.issued_date) return '';
      const date = DateTimeUtils.parseDate(this.formModel.issued_date);
      return `Ngày ${date.date()} tháng ${date.month() + 1} năm ${date.year()}`;
    },
    signedDate() {
      if (!this.formModel.signed_date) return '';
      const date = DateTimeUtils.formatDateTime(this.formModel.signed_date, 'YYYY-MM-DD HH:mm');
      return `${date}`;
    },
    generateTitle() {
      return this.formModel.invoice_template_type || 'HÓA Đơn';
    },
    generateDescription() {
      let desc = '';
      if (this.formModel.original_invoice_number || this.formModel.original_invoice_serial || this.formModel.original_issuance_date) {
        desc += `${this.$t(`invoice.invoiceTypes.${this.formModel.invoice_type.toLowerCase()}`)} ${this.$t('invoice.forInvoiceSerial')} <strong>${this.formModel.original_invoice_serial}</strong>,  ${this.$t('invoice.invoiceNumber2')} <strong>${this.formModel.original_invoice_number}</strong>,  ${this.$t('invoice.createdDate')} <strong>${this.formModel.original_issuance_date}</strong>`;
      }
      return desc;
    },
    generatePaymentMethod() {
      if (!this.formModel.payment_method) return null;
      let result = '';
      const pm = this.formModel.payment_method.split(', ');
      pm.forEach((item) => {
        switch (item) {
          case 'TM':
            result += 'Tiền mặt, ';
            break;
          case 'CK':
            result += 'Chuyển khoản, ';
            break;
          default:
            break;
        }
      });
      return result.slice(0, -2);
    },
    generateContent() {
      const { id, content: formContent, metadata } = this.formModel;
      const content = formContent || this.detailsInvoice.get(id);

      if (!content) {
        this.isGetDetailError = true;
        return null;
      }

      // Nếu có cả content và formModel tồn tại trong map => xóa
      if (formContent && this.detailsInvoice.has(id)) {
        const newDetailsInvoice = new Map(this.detailsInvoice);
        newDetailsInvoice.delete(id);
        this.setState({ detailsInvoice: newDetailsInvoice });
      }

      const data = parseInvoiceContent(content);

      if (data && data.length > 0) {
        return data;
      }

      // Nếu không parse được data, fallback sang metadata (chỉnh sửa)
      if (metadata && metadata.modify) {
        const product = {
          PRODUCT_NO: null,
          PRODUCT_DESC: null,
          PRODUCT_UNIT: null,
          PRODUCT_QUANTITY: null,
          PRODUCT_UNIT_PRICE: null,
          PRODUCT_AMOUNT: null,
          PRODUCT_VAT_RATE: null,
          PRODUCT_TAX_AMOUNT: null,
          PRODUCT_TOTAL_AMOUNT: null,
        };
        if (metadata.note_change && metadata.modify === 'INFORMATION') {
          return [{ ...product, PRODUCT_DESC: metadata.note_change }];
        }
      }

      return [];
    },
    invoiceType() {
      if (
        !this.formModel ||
        !this.formModel.metadata ||
        !this.formModel.metadata.invoice_common_code ||
        !this.formModel.invoice_serial
      ) {
        return '';
      }

      const code = this.formModel.metadata.invoice_common_code;
      const serial = this.formModel.invoice_serial;
      const index = code.indexOf(serial);

      if (index === -1) return '';

      return code.substring(0, index);
    },
  },
  watch: {
    formModel() {
      this.isGetDetailError = false;
      if (this.formModel.id && !this.detailsInvoice.has(this.formModel.id) && !this.formModel.content) this.onGetContent();
    },
  },
};
</script>
<style lang="scss" scoped>
.px-15px {
  padding: 0px 15px;
}

.background {
  width: 650px;
  height: 400px;
  position: absolute;
  top: calc(50% - 200px);
  left: calc(50% - 320px);
  opacity: .4;
  z-index: -1;
}

.invoice-form-viewer {
  position: relative;
  font-size: 14px;
  padding: 1rem;
  margin: 1.5rem;
  border: 2px solid #7E9BD5;
  outline: 0.75rem solid #FCFDFF;
  background: url('/images/thue-nha-nuoc.png') center #FCFDFF no-repeat;
  background-size: 800px;

  @media screen and (max-width: 1560px) {
    background-size: 700px;
  }

  @media screen and (max-width: 768px) {
    background-size: 400px;
  }

  .table {
    .content {
      margin-top: 16px;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .custom-btn {
        background-color: #E5F2FF;
      }
      .custom-btn:hover {
        background-color: #0078d4;
      }
    }
    tbody {
      border-bottom: 2px solid #dee2e6;
    }
  }

  .view-total-container {
    display: flex;
    justify-content: end;
    width: 100%;

    .view-total-content {
      display: flex;
      flex-direction: column;
      min-width: 320px;

      @media screen and (max-width: 768px) {
        min-width: 100%;
      }

      .view-total-item {
        display: flex;
        color: #005DCA;
        justify-content: space-between;
        align-items: center;
        span {
          margin-bottom: 8px;
        }
      }

      .view-total-item:last-of-type {
        font-weight: bold;
      }
    }
  }

  .invoice-form-footer {
    p {
      margin-bottom: 0;
    }

    strong {
      font-weight: 900 !important;
    }

    .tax-code {
      gap: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        font-weight: 700;
      }
    }
  }
}

.invoice-form-viewer:before {
  background: none;
  border: 1px solid #7EADE4;
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  pointer-events: none;
}

.invoice-form-viewer:after {
  background: none;
  content: "";
  display: block;
  position: absolute;
  top: -1rem;
  left: -1rem;
  right: -1rem;
  bottom: -1rem;
  pointer-events: none;
  box-shadow: 0px 4px 4px 0px #002E511A;
}

.header {
  position: relative;
  text-align: center;
  padding: 60px 0 0 0;

  .title {
    font-size: 20px;
    font-weight: 800;
    margin-bottom: 0;
    text-transform: uppercase;
  }

  .description {
    strong {
      font-weight: 900 !important;
    }
  }

  //.italic {
  //  font-style: italic;
  //}
  p {
    margin-bottom: 0;
  }

  .top-right-content {
    position: absolute;
    width: 180px;
    right: 20px;
    top: 0px;
    text-align: start;
  }
  .top-left-content {
    position: absolute;
    left: 20px;
    top: 0px;
    text-align: start;
    .check-valid-invoice {
      display: flex;
      gap: 4px;
      padding: 4px 8px;
      border-radius: 5px;
      color: #2BD700;
      border: 2px solid #2BD700;
      p {
        font-weight: 500;
      }
    }
    .uncheck-valid-invoice {
      display: flex;
      gap: 4px;
      padding: 4px 8px;
      color: #0078D4;
      border-bottom: 2px solid #0078D4;
      p {
        font-weight: 500;
      }
    }
    button {
      margin-top: 12px;
    }
  }
}

.signature {
  padding: 1rem 0 1rem 0;

  strong {
    font-weight: 900 !important;
  }

  .p-sign {
    margin-top: 1rem;
    width: 240px;
    padding: 4px 16px 8px 16px;
    border-radius: 8px;
    border: 2px solid #2BD700;
    display: flex;
    flex-direction: column;
    position: relative;

    .content {
      color: #2BD700;
      padding-bottom: 4px;
    }

    p {
      margin: 0;
      text-align: start;
    }

    .icon {
      position: absolute;
      bottom: 8px;
      right: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-form-viewer.vue